import type { SafeString } from '@ember/template';
import Component from '@glimmer/component';
import { getLocalTime } from 'frontend-utils/utils/dayjs';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';
import type { Period } from 'lumen/models';
import type { HotelOrMarket } from 'lumen/services/hotel-and-market';

interface ParityOtaParityLinkSignature {
  Args: {
    city?: boolean;
    hotel: HotelOrMarket;
    ota: string;
    period: Period;
    persons: number;
    pos?: string;
    value: string | SafeString | null;
  };
}

export default class ParityOtaParityLink extends Component<ParityOtaParityLinkSignature> {
  get generatedOtaLink(): string {
    const hotelInfoId = this.args.hotel.hotelinfo.id;
    const hotelId = this.args.hotel.id;
    const { isTripadvisorRebranding } = this.args.hotel;

    return generateOtaLink(
      this.args.ota,
      hotelInfoId!,
      hotelId!,
      isTripadvisorRebranding,
      this.args.period,
      this.args.persons,
      'app_parity',
      this.args.city,
      this.args.pos,
    );
  }

  get showOtaLink(): boolean {
    if (!this.args.ota || !this.args.period || !this.args.value) {
      return false;
    }

    const localTime = getLocalTime(this.args.hotel?.hotelinfo?.timezone);

    return !(
      this.args.period?.fromDate.isBefore(localTime, 'day') &&
      !this.args.period?.fromDate.isSame(localTime, 'day')
    );
  }

  <template>
    <a
      href={{this.generatedOtaLink}}
      rel="noopener noreferrer"
      target="_blank"
    >{{@value}}</a>
  </template>
}
